import { CookieInfoApi } from 'src/app/models/api.model'
import { CookieInfoApiService } from './cookie-info-api.service'

declare global {
  interface Window {
    DPM_COOKIE_INFO: CookieInfoApi
  }
}

export class UMDApiService {
  private static instance: UMDApiService
  private readonly cookieInfoApiService: CookieInfoApiService

  private constructor() {
    this.cookieInfoApiService = CookieInfoApiService.getInstance()
  }

  static getInstance(): UMDApiService {
    if (UMDApiService.instance === undefined) {
      UMDApiService.instance = new UMDApiService()
    }

    return UMDApiService.instance
  }

  createGlobalApiObject(): void {
    const apiObject = this.cookieInfoApiService.getInitialPublicApi()

    window.DPM_COOKIE_INFO = apiObject
  }
}
